<template>
  <div>
    <!-- 头部 S-->

    <Head></Head>
    <!-- 头部 E -->
    <div class="main w">
      <h6>
        キーワード：{{ $route.query.result }}
        <span>検索結果に問題あり？</span>
        <em>
          全
          <b>{{ amount }}</b>件の関係商品
        </em>
      </h6>
      <!-- main 头部-->
      <div class="main-top">
        <dl>
          <dt>仕入れ先：</dt>
          <dd>すべて</dd>
          <dd @click="typeDite('rakumart')">
            RAKUMART
            <img src="../../assets/img/rakumart.png" alt />
          </dd>
          <dd @click="typeDite(1688)" :class="{ cur: $route.query.type == '1688' }">
            Alibaba
            <img src="../../assets/img/1688.png" alt />
          </dd>
          <dd @click="typeDite('taobao')" :class="{ cur: $route.query.type == 'taobao' }">
            TAOBAO
            <img src="../../assets/img/taobao.png" alt />
          </dd>
          <dd @click="typeDite('tmall')" :class="{ cur: $route.query.type == 'tmall' }">
            TMALL
            <img src="../../assets/img/tmall.png" alt />
          </dd>
        </dl>
      </div>
      <!-- 筛选 -->
      <div class="main-map">
        <span>综合</span>
        <ul>
          <li>
            取引数
            <i class="el-icon-caret-top" id="i-top" @click="getMin"></i>
            <i class="el-icon-caret-bottom" id="i-bottom" @click="getMax"></i>
          </li>
          <li>
            価格
            <i class="el-icon-caret-top" id="i-top"></i>
            <i class="el-icon-caret-bottom" id="i-bottom"></i>
            <input type="text" v-model="list.priceStart" oninput="value=value.replace(/[^\d]/g, '')" />
            -
            <input type="text" v-model="list.priceEnd" style="margin: 0" oninput="value=value.replace(/[^\d]/g, '')"
              @blur="interval" @keydown.enter="interval" />
          </li>
          <li>
            最小ロット
            <input type="text" v-model="least" style="margin-right: 10px" oninput="value=value.replace(/[^\d]/g, '')" />
            <el-button size="mini">搜索</el-button>
          </li>
          <li class="place">
            所在地
            <i class="el-icon-caret-bottom"></i>
            {{ list.province }}
            <div class="localtion"></div>
          </li>
        </ul>
      </div>
      <!-- 商品 -->
      <div class="commodity" v-if="amount !== ''">
        <!-- 1688 -->
        <ul>
          <li v-for="(item,index) in lists.content" :key="index" @click="
  getSearchGoodsList1688(
              item
             
            )
            ">
            <div class="mian-item-img">
              <img :src="item.picurl" alt />
            </div>
            <span>￥{{ item.price }}</span>
            <span style="color: #f3c622; margin-left: 30px">{{ Math.ceil(item.price * exchangeRate) }}(円)</span>
            <p>{{ item.title }}</p>
          </li>
        </ul>
        <!-- 分页 -->
        <div class="fenye">
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage4" :page-size="20"
            layout="total, prev, pager, next, jumper" :total="amount"></el-pagination>
        </div>
      </div>
      <!-- 搜索错误 -->
      <div v-else>
        <error></error>
      </div>
    </div>
    <!-- <div class="w">
      <iframe
        id="ifra"
        name="ifra"
        width="900px"
        height="730px"
        src="http://localhost:8082/#/characterSecognition?img=https%3A%2F%2Fimg.alicdn.com%2Fi4%2F3709194471%2FO1CN01tqX9191itlW2UsHdE_%21%210-item_pic.jpg"
      ></iframe>
    </div> -->

    <!-- 尾部 -->
    <Foot></Foot>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Head from "../../components/head/Head";
import Foot from "../../components/foot/Foot";
import error from "./error";
import { getList, getList1688, getGoodsId } from "../../api/API/list";
export default {
  data() {
    return {
      imgFlag: false,
      least: "", // 最少手数
      list: {
        // 发送请求参数
        q: "",
        type: "",
        page: 1,
        sortType: "price",
        descendOrder: false,
        priceStart: "",
        priceEnd: "",
        province: "",
      },
      lists: [], // 返回数据
      amount: 0, // 总数量
      total: 1, // 当前页
      currentPage4: 1,
      // 搜索错误
      radio: 0,
      suggest: "",
    };
  },
  components: {
    Head,
    Foot,
    error,
  },
  created() {
    if (this.$route.query.img != undefined) {
      this.imgList();
    } else {
      this.getList();
    }
  },
  computed: {
    ...mapState(["result", "exchangeRate", "imgData"]),
  },
  methods: {
    ...mapMutations(["particulars"]),
    // 请求数据
    getList() {
      this.list.q = this.$route.query.result;
      if (this.$route.query.type != undefined) {
        this.list.type = this.$route.query.type;
      }
      getList1688(this.list).then((res) => {
        if (res.code != 1) return;
        this.lists = res.data;
        if (res.data.content != null) {
          this.amount = res.data.results - 0;
        } else {
          this.amount = "";
        }
      });
    },
    // 图片搜索数据
    imgList() {
      if (this.list.page == 1) {
        this.lists.content = this.imgData.slice(0, 20);
      } else {
        this.lists.content = this.imgData.slice((this.list.page - 1) * 20, this.list.page * 20);
      }
      // console.log(this.lists.content);
      this.amount = this.imgData.length;
      this.imgFlag = true;
      this.$forceUpdate();
    },
    // 筛选 类型
    typeDite(type) {
      if (type == "rakumart") {
        this.$router.push({
          path: "/list?result=" + this.list.q,
        });
      } else {
        this.list.type = type;
        this.$router.push({
          query: (this.$route.query, { result: this.list.q, type: type }),
        });
        this.getList();
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {

      this.list.page = val;
      if (this.imgFlag) {
        this.imgList();
      } else {
        this.getList();
      }
      window.scrollTo(0, 0);

    },
    //商品详情 1688
    getSearchGoodsList1688(item) {     
      let routeUrl = this.$router.resolve({
        path: `/details1688?iid=${ item.iid ? item.iid : item.id}&type=${item.user_type ? item.user_type : item.type}${item.mi_id?'&mi_id='+item.mi_id:''}`,
      });
      window.open(routeUrl.href, "_blank");
    },
    // 排序 true
    getMin() {
      this.list.descendOrder = true;
      this.getList();
    },
    //排序 false
    getMax() {
      this.list.descendOrder = false;
      this.getList();
    },
    interval() {
      if ((this.list.priceStart != "") & (this.list.priceEnd != "")) {
        this.getList();
      }
    },
    // 重置页码
    resetPageNum() {
      this.list.page = 1;
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  h6 {
    margin: 45px 0 20px;
    font-size: 16px;

    span {
      margin-left: 33px;
      font-weight: 700;
    }

    em {
      float: right;
    }

    b {
      color: #f3c622;
    }
  }

  .main-top {
    height: 90px;
    border: 1px solid #ccc;
    margin-bottom: 20px;

    dl {
      line-height: 90px;
      font-size: 16px;
      font-weight: 700;

      dt {
        margin: 0 130px 0 110px;
        float: left;
      }

      dd {
        float: left;
        margin-left: 100px;
        cursor: pointer;

        &:hover {
          color: #f3c622;
          text-decoration: underline;
        }

        img {
          vertical-align: middle;
          margin-left: 10px;
        }
      }

      .cur {
        color: #f3c622;
        text-decoration: underline;
      }
    }
  }

  .main-map {
    height: 50px;
    background: #f2f2f2;
    margin-bottom: 30px;

    span {
      display: block;
      float: left;
      height: 50px;
      color: #333;
      text-align: center;
      width: 118px;
      line-height: 50px;
      background: #f3c622;
      font-size: 16px;
    }

    ul {
      float: left;

      li {
        position: relative;
        float: left;
        margin-left: 118px;
        font-size: 16px;
        line-height: 50px;

        #i-top {
          position: absolute;
          top: 12px;
        }

        #i-bottom {
          position: absolute;
          top: 23px;
        }

        input {
          margin-left: 20px;
          width: 100px;
          height: 20px;
        }
      }

      .place {
        &:hover .localtion {
          display: block;
        }

        position: relative;

        .localtion {
          position: absolute;
          left: -100px;
          height: 20px;
          width: 300px;
          height: 500px;
          background: #ccc;
          display: none;
        }
      }
    }
  }

  .commodity {
    overflow: hidden;

    ul {
      overflow: hidden;

      li {
        float: left;
        width: 276px;
        height: 380px;
        border: 2px solid transparent;
        margin-bottom: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;

        &:hover {
          border-color: #f3c622;
        }

        &:hover img {
          transform: scale(1.2);
        }

        .mian-item-img {
          width: 260px;
          height: 280px;
          margin: 10px 10px 12px;

          overflow: hidden;

          img {
            width: 260px;
            height: 280px;
            transition: all 0.3s;
          }
        }

        p {
          margin: 8px 0 0 10px;
          font-size: 14px;
          width: 260px;
          line-height: 20px;
          height: 40px;
          overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
          // overflow: hidden;
        }

        span {
          padding-left: 10px;
          font-size: 20px;
          font: 700;
          color: red;
        }
      }
    }

    .fenye {
      margin: 30px 0 50px;
      text-align: center;
    }
  }
}
</style>